import { usePaginatedApi } from "../../../swr/useApi";

import { productService } from "../../api_client";
import type {
    ProductDto,
    ProductsQueryDto,
} from "../../../api";

export function useProducts(query?: ProductsQueryDto) {
    return usePaginatedApi<ProductDto, ProductsQueryDto>({
        key: "products",
        serviceMethod: async (queryParams) => await productService.getProducts(queryParams),
        query: query,
    });
}